<template>
    <div class="contactContainer">
        <h1>Nous contacter</h1>
        <h2 class="mt-3">Une question ? Une recommandation ?</h2>
        <p>
            N’hésitez pas à nous en faire part sur
            <a class="label" href="mailto:care@delicorner.co" target="_blank">care@delicorner.co</a> <br/>ou bien
            <span class="label">rendez-vous sur le chat</span>!
        </p>

        <div class="contact">
            <div class="contact-text">
                <h2 class="mt-5">Participez à l'optimisation de votre Corner en ligne !</h2>
                <p>Chez Delicorner nous avons à coeur de vous fournir le service le plus complet et adapté possible ! Et
                    cela passe aussi par l'évolution de notre Corner en ligne. nous souhaiterions échanger avec vous,
                    utilisateurs du site. Nous souhaiterions connaitre vos envies, vos besoins, vos idées afin de créer
                    ensemble la meilleure aventure possible. Si l’expérience vous tente, n’hésitez pas à envoyer un mail
                    à
                    <a href="mailto:admin@delicorner.co" target="_blank">admin@delicorner.co</a>
                </p>
            </div>
            <img alt="" class="contactIllustration" src="/svg/Illu contact-02.png"/>
        </div>
    </div>
</template>

<style scoped>
.contactContainer {
    height: calc(100vh - 6rem);
    overflow: hidden;
    position: relative;
}

h1 {
    font-size: 3.2em;
    margin-bottom: 40px;
}

h2 {
    font-size: 1.7em;
    color: var(--main-red);
    margin-bottom: 20px;
}

h3 {
    font-size: 24px;
}

p {
    @apply mt-6;
    font-size: 1em;

    a {
        text-decoration: underline;
        font-weight: bold;
    }
}

.contact {
    display: flex;
    justify-content: space-between;

    .contact-text {
        flex: 0 0 50%;
    }

    .contactIllustration {
        position: absolute;
        right: -190px;
        transform: rotate(-60deg);
        width: 600px;
    }
}
</style>
<script setup>
export default {}
</script>
